import {instance} from ".";

export const getOrganizationsList = () => {
  return instance({
      method: "get",
      url: "/work/api/organization"
    });
};

export const getOrganizationsSelectList = () => {
  return instance({
    method: "get",
    url: "/work/api/organization?mode=select"
  });
};

export const deleteOrganization = id => {
  return instance({
      method: "delete",
      url: `/work/api/organization/${id}`
    });
};

export const getOrganizationCard = id => {
  return instance({
      method: "get",
      url: `/work/api/organization/${id}/card`
    });
};

export const getOrganizationWorldSkills = id => {
  return instance({
      method: "get",
      url: `/work/api/organization/${id}/service/world-skill`
    });
};

export const getOrganizationSpecialities = id => {
  return instance({
      method: "get",
      url: `/work/api/organization/${id}/service/speciality`
    });
};

export const getRegions = () => {
  return instance({
      method: "get",
      url: "/work/api/dict/region"
    });
};

export const getMunicipals = regionId => {
  return instance({
      method: "get",
      url: "/work/api/dict/municipal",
      params: {
        regionId
      }
    });
};

export const getOrganizationFullInfo = id => {
  return instance({
      method: "get",
      url: `/work/api/organization/${id}`
    });
};

export const updateOrganization = (id, info) => {
    const { specialities, worldSkills, main, services, bank, about } = info;
    const mapId = arr => arr.map(i => i.id);

  return instance({
      method: "put",
      url: `/work/api/organization/${id}`,
      data: {
        main,
        specialities: mapId(specialities),
        worldSkills: mapId(worldSkills),
        service: services,
        bank: bank,
        about: about
      }
    });
};

export const updateOrganizationProfile = (id, info) =>{
  return instance({
    method: "post",
    url: `/work/api/organization/rpc`,
    data: {
      type: "set-curator",
      orgId: id,
      personId: info.personId,
      roles: info.roles
    }
  });
}

export const createOrganization = data => {
  return instance({
      method: "post",
      url: `/work/api/organization/`,
      data
    });
};

export const getFormPersons = () => {
  return instance({
      method: "get",
      url: `/work/api/person`
    });
};

export const getOrganizationFiles = id => {
  return instance({
      method: "get",
      url: `/work/api/organization/${id}/main/request/attachment`
    });
};

export const addOrganizationFile = (id, file) => {
    const data = new FormData();
    data.set("attachment", file);

  return instance({
      method: "post",
      url: `/work/api/organization/${id}/main/request/attachment`,
      headers: {
        "Content-Type": "multipart/form-data"
      },
      data
    });
};

export const deleteOrganizationFile = (orgId, fileId) => {
  return instance({
      method: "delete",
      url: `/work/api/organization/${orgId}/main/request/attachment/${fileId}`
    });
};

export const getOrganizationServices = id => {
  return instance({
      method: "get",
      url: `/work/api/organization/${id}/service`
    });
};

export const getOrganizationBankCreds = id => {
  return instance({
      method: "get",
      url: `/work/api/organization/${id}/bank`
    });
};

export const getOrganizationProfileInfo = id => {
  return instance({
      method: "get",
      url: `/work/api/organization/${id}/system`
    });
};

export const getOrganizationStaff = (id) => {
  return instance({
      method: "get",
      url: `/work/api/organization/${id}/staff/`
    });
};

export const getRolesDict = () => {
  return instance({
      method: "get",
      url: `/work/api/dict/role`
    });
};

export const getPostsDict = () => {
  return instance({
      method: "get",
      url: `/work/api/dict/18`
    });
};

export const getPersonRoles = (id) => {
  return instance({
      method: "get",
      url: `/work/api/person/${id}/system/role`
    });
};

export const createNewPerson = (orgId, data) => {
  return instance({
      method: "post",
      url: `/work/api/organization/${orgId}/person`,
      data
    });
};

export const addExistingPerson = (orgId, data) => {
  return instance({
      method: "post",
      url: `/work/api/organization/${orgId}/staff`,
      data
    });
};

export const deleteEmployee = (orgId, staffId) => {
  return instance({
      method: "delete",
      url: `/work/api/organization/${orgId}/staff/${staffId}`
    });
};

export const blockEmployee = id => {
  return instance({
      method: "post",
      url: `/work/api/person/rpc`,
      data: {
        type: "block",
        id
      }
    });
};

export const updateEmployee = (orgId, staffId, data) => {
  return instance({
      method: "put",
      url: `/work/api/organization/${orgId}/staff/${staffId}`,
      data
    });
};

export const getOrganizationDepartments = (orgId) => {
  return instance({
      method: "get",
      url: `/work/api/organization/${orgId}/department`
    });
};

export const updateDepartments = (orgId, main) => {
  return instance({
    method: "put",
    url: `/work/api/organization/${orgId}/department`,
    data: {
      departments: main
    }
  });
};

export const updateLogo = (orgId, file) => {
  const data = new FormData();
  data.set('logo', file);

  return instance({
    method: "post",
    url: `/work/api/organization/${orgId}/logo`,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data
  });
};

export default {
    getOrganizationsList,
    getOrganizationsSelectList,
    deleteOrganization,
    createOrganization,
    getOrganizationCard,
    getOrganizationFullInfo,
    updateOrganization,
    getOrganizationWorldSkills,
    getOrganizationSpecialities,
    getOrganizationProfileInfo,
    getRolesDict,
    getPersonRoles,
    getRegions,
    getMunicipals,
    getFormPersons,
    getOrganizationFiles,
    deleteOrganizationFile,
    getOrganizationServices,
    getOrganizationBankCreds,
    getOrganizationStaff,
    getOrganizationDepartments,
    getPostsDict,
    createNewPerson,
    addExistingPerson,
    deleteEmployee,
    blockEmployee,
    updateEmployee,
    updateDepartments,
    updateOrganizationProfile,
    addOrganizationFile,
    updateLogo
};
